import React, { useState } from "react";
import classes from "./DndMain.module.scss";
// import ScrollButton from "../../uikit/atoms/buttons/ScrollButton";
import DndArea from "../../dnd/DndArea";
import HeaderController from "../../dnd/HeaderController";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  columnOrderState,
  columnVisibilityState,
} from "../../../states/columnState";
import { useNavigate } from "react-router-dom";
import { useUserStateLocalstorage } from "../../../hooks/useUserStateLocalstorage";
import { userState } from "../../../states/userState";
import { backgroundColor, backgroundColorDnd } from "../../../commons/colors";
type localColumn = {
  [key: string]: boolean;
};
const DndMain = () => {
  const { updateColumnsOrderAndVisibility } = useUserStateLocalstorage();
  const user = useRecoilValue(userState);
  const navigation = useNavigate();
  //Recoilの状態を取得
  const [columnVisibility, setColumnVisibility] = useRecoilState(
    columnVisibilityState
  );
  const [columnOrder, setColumnOrder] = useRecoilState(columnOrderState);
  //ローカルの状態を定義
  const [isShowAll, setIsShowAll] = useState<boolean>(true);

  //保存ボタンがクリックされたとき
  const handleSaveButtonClick = () => {
    const newVisibility = localColumns.reduce((acc, cur) => ({
      ...acc,
      ...cur,
    }));
    const newOrder = localColumns.map((column) => Object.keys(column)[0]);
    // console.log("Dnd newVisibility", newVisibility, "newOrder", newOrder);
    setColumnVisibility(newVisibility);
    setColumnOrder(newOrder);
    //updateColumnsOrder(newOrder);
    updateColumnsOrderAndVisibility(newVisibility, newOrder);

    navigation("/");
  };

  //ローカルのカラムの状態を定義
  const createLcalColmuns = () => {
    const localColumnVisiblity = { ...columnVisibility };
    const localColumnOrder = [...columnOrder];

    const newColumns: localColumn[] = localColumnOrder.map((column) => {
      return { [column]: localColumnVisiblity[column] };
    });
    // console.log("newColumns", newColumns);
    return newColumns;
  };
  const [localColumns, setLocalColumns] = useState<localColumn[]>(
    createLcalColmuns()
  );
  // console.log(
  //   "DndMainがレンダリングされました",
  //   "columOrder",
  //   columnOrder,
  //   "columnVisibility",
  //   columnVisibility
  // );

  return (
    <div
      className={classes.rootContainer}
      style={backgroundColorDnd(user?.mode ?? "lite")}
    >
      <HeaderController
        handleSaveButtonClick={handleSaveButtonClick}
        isShowAll={isShowAll}
        setIsShowAll={setIsShowAll}
        setLocalColumns={setLocalColumns}
      />
      <DndArea
        setLocalColumns={setLocalColumns}
        localColumns={localColumns}
        isShowAll={isShowAll}
      />
      {/* <ScrollButton /> */}
    </div>
  );
};

export default DndMain;
